<template>
    <section v-if="json" class="page-games" >
        <FeaturedGames :json="json" type="top"></FeaturedGames>
        <Timeline :json="json"></Timeline>
        <FeaturedGames :json="json" type="bottom"></FeaturedGames>
    </section>
</template>
<script>
import axios from 'axios'
//import gsap, {} from 'gsap'
//import { SplitText} from 'gsap/SplitText'
import { mapState } from 'vuex'
import FeaturedGames from "@/components/blocks/FeaturedGames"
import Timeline from "@/components/blocks/Timeline"
import gh from "@/helpers/gh";
//gsap.registerPlugin(SplitText)
export default {
    name: "GamesPage",
    components: {
        FeaturedGames,
        Timeline
    },
    data () {
        return {
            window: window,
            json: null,
            inPanelTransition: false,
            revealReady:false
        }
    },
    created () {

    },
    computed: {
        ...mapState({
            didInitialSiteTransition: state => state.didInitialSiteTransition
        }),
    },
    mounted () {
        const turl = gh.formatFeedUrl('games')
        axios.get((turl))
            .then((res) => {
                this.json = res.data

                if (this.didInitialSiteTransition) {
                    if (!this.inPanelTransition) {
                        setTimeout(this.reveal,10)
                    }
                }

            }).catch(() => {
        })
    },
    watch: {
        didInitialSiteTransition() {
            if (!this.inPanelTransition) {
                this.reveal()
            }

        }
    },
    methods: {
        reveal: async function() {
            this.inPanelTransition = true

            this.reveal2()
        },
        reveal2 () {

        },

        revealReadyMethod () {
            this.revealReady = true
        }
    }
}
</script>
<style lang="scss" scoped>
.test {
    margin: 80px 0;
    display: flex;
    justify-content: space-between;
    gap: 40px;
    align-items: stretch;
    img {
        height: 100%;
        width: auto;
        object-fit: contain;
    }
}
</style>
